import dayjs, { Dayjs } from 'dayjs'

import DateHourRange from '@/classes/DateHourRange'

export type HolidayRange = [Dayjs, Dayjs]
export type HolidayRanges = Record<string, HolidayRange>

export const format = 'YYYY-MM-DD'

/** 連假日期區間列表 */
const defaultHolidays: HolidayRanges = {
  '2021DragonBoatFestival': [
    dayjs('2021-06-12', format),
    dayjs('2021-06-14', format),
  ],
}

/** 判斷指定的日期區間是否逢連假 */
export function isDuringHoliday (
  range: DateHourRange,
  holidays: HolidayRanges = defaultHolidays
): boolean {
  const {
    start: { date: start },
    end: { date: end },
  } = range

  if (!(range.isValid && start && end)) return false

  const options = ['date', '[]'] as const

  return Object.values(holidays).some(holiday => (
    start.isBetween(...holiday, ...options) || // a. 頭在連假內
    end.isBetween(...holiday, ...options) || // b. 尾在連假內
    ( // c. 連假在頭尾內
      holiday[0].isBetween(start, end, ...options) &&
      holiday[1].isBetween(start, end, ...options)
    )
  ))
}
